import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface NewMotorDetails {
    motorNumber: number;
    distributionCenter: string;
    power: number;
    unitType: string;
    voltage: number;
}

export interface MotorSpecifications {
    motorId: string | null;
    powerKw: number | null;
    powerHp: number | null;
    frequency: number | null;
    voltage: number | null;
    current: number | null;
    serviceFactor: number | null;
    flangeDiameter: number | null;
    shaftHeight: number | null;
}

export interface MotorComparison {
    oldMotor: MotorSpecifications;
    newMotor: MotorSpecifications;
}

export interface MotorComponent {
    legend: string | null;
    partNumber: string;
    partDescription: string;
    quantity: number;
}

export interface MotorComponentSet {
    motorImage: string;
    motorBaseImage: string,
    component: MotorComponent[];
}

export interface MotorComponentData {
  partToOrder: MotorComponent[];
  oldMotorComponent:MotorComponentSet;
  newMotorComponent:MotorComponentSet;
}

export interface MotorSalesCalculator {
    oldMotorPower: number | null;
    newMotorPower: number;
    oldMotorEfficiency: number | null;
    newMotorEfficiency: number | null;
    oldMotorEfficiencyClass: string | null;
    newMotorEfficiencyClass: string | null;
}

export interface MotorInvestigationDetailsResponse {
    newMotorDetails: NewMotorDetails;
    motorComparison: MotorComparison;
    motorComponents: MotorComponentData;
    fieldInstruction: string;
    motorSalesCalculator: MotorSalesCalculator;
    documents: string[];
}

export interface FetchMotorInvestigationDetailsParams {
    OldMotorNumber?: number;
    VoltageV?: number;
    PowerKw?: number;
    FrequencyHz?: number;
    ModelName?: string;
    Region?: string;
    IsSolutionForSerialNumber?: boolean;
}

const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL environment variable is not set');
}
const baseQuery = createBackendBaseQuery(BASE_URL);

export const motorInvestigationDetailsApiSlice = createApi({
  reducerPath: 'motorInvestigationDetailsApi',
  baseQuery: baseQuery,
  tagTypes: ['MotorInvestigationDetails'],
  endpoints(builders) {
    return {
      fetchMotorInvestigationDetails: builders.query<
        MotorInvestigationDetailsResponse,
        FetchMotorInvestigationDetailsParams | void
      >({
        query: (params) => {
          let queryString = '';
          if (params) {
            const usp = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== '') {
                usp.append(key, String(value));
              }
            });
            queryString = usp.toString() ? `?${usp.toString()}` : '';
          }
          return {
            url: `${API_URLS.MOTOR_SERVICE.INVESTIGATION_DETAILS}${queryString}`,
            method: 'GET',
          };
        },
        providesTags: ['MotorInvestigationDetails'],
        transformErrorResponse: transformApiError,
      }),  
    };
  },
});

export const {
    useFetchMotorInvestigationDetailsQuery,
    useLazyFetchMotorInvestigationDetailsQuery,
} = motorInvestigationDetailsApiSlice;
